import React from "react";
import { Group, Circle } from "react-konva";

import { ICoordinate } from "types";

interface ITouchPointProps {
  points: ICoordinate[];
}

export const TouchPoint = ({ points = [] }: ITouchPointProps) => {
  return (
    <Group>
      {points.map((point, index) => (
        <Circle key={index} x={point.x} y={point.y} radius={4} fill="#ff1744" />
      ))}
    </Group>
  );
};
